import React from "react";

export default function IconView() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4569 8.20307C15.4569 8.20307 15.3173 8.51721 15.0325 8.96953C15.0325 8.96953 14.4713 9.86076 13.7286 10.6036C13.7286 10.6036 11.3321 13 8 13C8 13 4.66789 13 2.27145 10.6036C2.27145 10.6036 1.52865 9.86076 0.967509 8.96953C0.967509 8.96953 0.68271 8.5172 0.543094 8.20307C0.485635 8.07379 0.485635 7.92621 0.543094 7.79693C0.543094 7.79693 0.682709 7.4828 0.967509 7.03047C0.967509 7.03047 1.52865 6.13924 2.27145 5.39645C2.27145 5.39645 4.6679 3 8 3C8 3 11.3321 3 13.7286 5.39645C13.7286 5.39645 14.4713 6.13924 15.0325 7.03047C15.0325 7.03047 15.3173 7.48279 15.4569 7.79693C15.5144 7.92621 15.5144 8.07379 15.4569 8.20307ZM14.1863 8.43672C14.1863 8.43672 14.3416 8.18992 14.4429 8C14.4429 8 14.3417 7.81008 14.1863 7.56328C14.1863 7.56328 13.6849 6.767 13.0214 6.10355C13.0214 6.10355 10.9179 4 8 4C8 4 5.08211 4 2.97855 6.10355C2.97855 6.10355 2.3151 6.76701 1.81374 7.56328C1.81374 7.56328 1.65835 7.81007 1.55706 8C1.55706 8 1.65835 8.18993 1.81374 8.43672C1.81374 8.43672 2.3151 9.23299 2.97855 9.89645C2.97855 9.89645 5.08211 12 8 12C8 12 10.9179 12 13.0214 9.89645C13.0214 9.89645 13.6849 9.233 14.1863 8.43672Z"
        fill="#1C1C1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5C8 5 9.24264 5 10.1213 5.87868C10.1213 5.87868 11 6.75736 11 8C11 8 11 9.24264 10.1213 10.1213C10.1213 10.1213 9.24264 11 8 11C8 11 6.75736 11 5.87868 10.1213C5.87868 10.1213 5 9.24264 5 8C5 8 5 6.75736 5.87868 5.87868C5.87868 5.87868 6.75736 5 8 5ZM8 6C8 6 7.17157 6 6.58579 6.58579C6.58579 6.58579 6 7.17157 6 8C6 8 6 8.82843 6.58579 9.41421C6.58579 9.41421 7.17157 10 8 10C8 10 8.82843 10 9.41421 9.41421C9.41421 9.41421 10 8.82843 10 8C10 8 10 7.17157 9.41421 6.58579C9.41421 6.58579 8.82843 6 8 6Z"
        fill="#1C1C1C"
      />
    </svg>
  );
}
